var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('my-header'),_c('router-view',{key:_vm.$route.meta.key || _vm.$route.fullPath,staticClass:"scale-container"}),_c('my-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }